<template>
  <div class="certification-alert-wrap" v-if="!(isAuthPage)&&($store.state.auth.isCertificated===false)&&!($store.state.auth.certificateType==5)">
		<el-alert class="certification-alert" type="warning" show-icon>
			<p slot="title" class="go-auth-tip"  v-if="!isCompanyPage">
				为保证账户安全，平台将对未实名认证用户进行能力调用次数以及其他权益限制，建议您优先完成实名认证<router-link to="/user/authentication">立即实名认证 >></router-link>
			</p>
			<p slot="title" class="go-auth-tip" v-else>
				企业实名认证后，此账号将归属于认证企业。此账号今后在平台的任何操作，都视为企业授权行为。认证企业在提交申诉信息和有效证明文件前提下，可合理变更账号信息及操作权限。
			</p>
		</el-alert>
  </div>
</template>
<script>
	import ajax from 'api/userauth'
	
	export default {
		data() {
			return {
				isAuthPage: '',
				isCompanyPage: false,
				routerPath: this.$route.path
			}
		},
		watch: {
			'$route' (to, from) {
				let _t = this
				if(_t.$route.path === '/user/authentication/company'){
					_t.isCompanyPage = true
				}else{
					_t.isCompanyPage = false
				}
				if(_t.$route.path === '/user/authentication') {
					_t.isAuthPage = true
				} else {
					_t.isAuthPage = false
				}
			}
		},
		mounted() {
			let _t = this
			if(_t.$route.path === '/user/authentication/company'){
					_t.isCompanyPage = true
			}else{
				_t.isCompanyPage = false
			}
			if(_t.$route.path === '/user/authentication') {
				_t.isAuthPage = true
			} else {
				_t.isAuthPage = false
			}
		}
	}
</script>
<style>
	.el-alert__icon.is-big {
		display: table-cell;
	}
	.el-alert__content {
    vertical-align: middle;
	}
</style>

<style scoped>
	.certification-alert-wrap .el-alert--warning.is-light {
			border-radius: 0px;
			padding: 5px 16px;
			border-bottom: solid 1px #f5e3bf;
	}
	.go-auth-tip {
		color: #0f9de7;
		font-size: .14rem;
		line-height: .28rem;
		color: #f93;
	}
	.go-auth-tip a {
		margin-left: .1rem;
		color: #409EFF;
	}
</style>




// WEBPACK FOOTER //
// app/components/CertificationAlert/Main.vue